// extracted by mini-css-extract-plugin
module.exports =  {"quickAddDesktopRoot":"hvHieT","animateIn":"_3JWNK","animateOut":"PIqAUM","quickAddDesktopContent":"vEBgDX"};